import produce from 'immer';
import {
  COMERCIA_WIFI_AUTHORIZE_API_FAILURE,
  COMERCIA_WIFI_AUTHORIZE_API_REQUEST,
  COMERCIA_WIFI_AUTHORIZE_API_SUCCESS,
  COMERCIA_WIFI_IS_AVALIABLE_API_REQUEST,
  COMERCIA_WIFI_IS_AVALIABLE_API_SUCCESS,
  COMERCIA_WIFI_NEW_TRANSACTION_REQUEST,
  COMERCIA_WIFI_REBATE_API_REQUEST,
  COMERCIA_WIFI_REBATE_API_SUCCESS,
  COMERCIA_WIFI_LAST_TRANSACTION_API_REQUEST,
  COMERCIA_WIFI_LAST_TRANSACTION_API_SUCCESS
} from '../actions/constants/comercia.datafono.wifi.constants';

const initialState = {
  api: {
    mode: null,
    status: null,
    orderId: null,
    response: null,
  },

}; 
/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["draft"] }] */
export default produce((draft = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case COMERCIA_WIFI_AUTHORIZE_API_REQUEST: {
      draft.api.status = 'WAITING';
      return draft;
    }
    case COMERCIA_WIFI_AUTHORIZE_API_SUCCESS: {
      const { orderId } = payload;
      draft.api.orderId = orderId;
      draft.api.status = 'CONFIRMED';
      draft.api.response = payload;
      return draft;
    }
    case COMERCIA_WIFI_AUTHORIZE_API_FAILURE: {
      draft.api.status = 'AUTHORIZE_ERROR';
      draft.api.response = payload;
      return draft;
    }
    case COMERCIA_WIFI_REBATE_API_REQUEST: {
      draft.api.status = 'WAITING';
      return draft;
    }
    case COMERCIA_WIFI_REBATE_API_SUCCESS: {
      const { orderId } = payload;
      draft.api.orderId = orderId;
      draft.api.status = 'CONFIRMED';
      draft.api.response = payload;
      return draft;
    }
    case COMERCIA_WIFI_LAST_TRANSACTION_API_REQUEST: {
      draft.api.status = 'WAITING';
      return draft;
    }
    case COMERCIA_WIFI_LAST_TRANSACTION_API_SUCCESS: {
      const { orderId } = payload;
      draft.api.status = 'CONFIRMED';
      draft.api.response = payload;
      return draft;
    }
    case COMERCIA_WIFI_IS_AVALIABLE_API_REQUEST: {
      draft.api.status = 'CONNECT';
      return draft;
    }
    case COMERCIA_WIFI_IS_AVALIABLE_API_SUCCESS: {
      draft.api.status = 'AVALIABLE';
      return draft;
    }
    case COMERCIA_WIFI_NEW_TRANSACTION_REQUEST: {
      const { mode } = payload;
      draft.api.mode = mode;
      return draft;
    }
    default: {
      return draft;
    }
  }
});
